import { Olympiad, ReducerAction } from './model';
import { OlympiadStatus } from './useOlympiadStore';
import { OlympiadsApi } from 'api';
import { Api } from 'api/cabmun-api-public';

const getRegionOlymp = (educationYarn: string, olympiadStatus: string) => {
  return OlympiadsApi.getOlyimpiadsListForRegion(educationYarn, olympiadStatus);
};

const getMunicipalityOlymp = (educationYarn: string, olympiadStatus: string) => {
  return OlympiadsApi.getOlyimpiadsList(educationYarn, olympiadStatus);
};

export const fetchOlympsList = async ({
  key,
  isRegion,
  educationYarn,
  olympiadStatus,
  dispatch,
  cabmunId,
}: {
  key: string;
  isRegion: boolean;
  educationYarn: string;
  olympiadStatus: OlympiadStatus;
  dispatch: React.Dispatch<ReducerAction>;
  cabmunId?: number;
}) => {
  dispatch({ type: 'startLoading', key: key });
  const olympiadRequest = (isRegion ? getRegionOlymp : getMunicipalityOlymp)(educationYarn, olympiadStatus);
  const ratingsRequest =
    olympiadStatus !== 'future' && !isRegion
      ? OlympiadsApi.getMunicipalityRatingsByOlympiads(educationYarn, olympiadStatus).catch(() => [])
      : [];

  try {
    const [olympiads, ratingsByOlympiads]: [Olympiad[], Api.GetMunicipalityRatingsByOlympiads200Response[]] =
      await Promise.all([olympiadRequest, ratingsRequest]).then(([olympiads, ratingsByOlympiads]) => [
        olympiads.olympiads!.map((el, index) => convertOlympiadFromApi(el, index, cabmunId)),
        ratingsByOlympiads,
      ]);

    dispatch({ type: 'setOlympiadsByKey', key: key, data: { olympiads, ratingsByOlympiads } });
  } catch (e) {
    dispatch({ type: 'errorLoading', key: key });
  }
};

export const convertOlympiadFromApi = (
  el: Api.GetOlyimpiadsList200Response.Olympiad | Api.GetOlyimpiadsListForRegion200Response.Olympiad,
  index: number,
  cabmunId?: number,
): Olympiad => ({
  id: el.olympiad_id || (index + Date.now()).toString(),
  ratingByRealStudentsCount: !!(el.olympiad_start && el.olympiad_start > '2023-11-27'),
  name: el.name,
  url: `${el.url?.replaceAll('{{cabmun_id}}', `${cabmunId}`)}` || '',
  icon: el.icon || '',
  attachments: el.attachments || [],
  dates: (el.dates || '').replace('-', '–'), //заменяю на среднее тире, никто кроме фронта не может это сделать
  description: el.description || '',
  total: {
    activeStudentsCount: el.total?.active_students_count || 0,
    participantsPercent: el.total?.participants_percent || 0,
    participantsCount: el.total?.participants_count || 0,
    prizeholdersPercent: el.total?.prizeholders_percent || 0,
    prizeholdersCount: el.total?.prizeholders_count || 0,
    realStudentsCount: (el as Api.GetOlyimpiadsList200Response.Olympiad).total?.real_students_count || null,
  },
  schools:
    (el as Api.GetOlyimpiadsList200Response.Olympiad).schools?.map((school) => ({
      municipalicy: school.municipalicy,
      schoolTitle: school.school_title,
      activeStudentsCount: school.active_students_count,
      participantsPercent: school.participants_percent,
      participantsCount: school.participants_count,
      prizeholdersPercent: school.prizeholders_percent || 0,
      prizeholdersCount: school.prizeholders_count || 0,
    })) || [],
  municipalities:
    (el as Api.GetOlyimpiadsListForRegion200Response.Olympiad).municipalities?.map((school) => ({
      municipalicy: school.municipalicy,
      schoolTitle: '',
      activeStudentsCount: school.active_students_count,
      participantsPercent: school.participants_percent,
      participantsCount: school.participants_count,
      prizeholdersPercent: school.prizeholders_percent || 0,
      prizeholdersCount: school.prizeholders_count || 0,
    })) || [],
  cards:
    el.cards?.map((card) => ({
      difficulty: card.difficulty,
      name: card.name,
      description: card.description,
      correctAnswersPercent: card.correct_answers_percent,
      correctAnswersPercentRussia: card.correct_answers_percent_russia,
    })) || [],
  ratingStaticData: {
    improve_button_link: el.rating?.improve_button_link,
    popup_text: el.rating?.popup_text?.replaceAll('{{cabmun_id}}', `${cabmunId}`),
  },
});
